import { isAfter } from 'date-fns'

export default function isAfterDateUtil (date, dateToCompare) {
  return isAfter(date, dateToCompare)
}
